import $ from 'jquery';
// import './tools/svg4everybody';
// import { MQ } from './tools/MQ';

// Components
// import * as fontFaceObserver from './components/fontFaceObserver';
import * as slick from './components/slick';
import * as linkSlide from './components/linkSlide';
import * as popupOpen from './components/popupOpen';
import * as formOpen from './components/formOpen';
import * as suggest from './components/suggest';
import * as inpCount from './components/inpCount';
import * as menuMain from './components/menuMain';
import * as fixed from './components/fixed';
import * as fancybox from './components/fancybox';
import * as ajaxFormFancybox from './components/ajaxFormFancybox';
import * as toggleClass from './components/toggleClass';
import * as transportPayment from './components/transportPayment';
import * as slider from './components/slider';
import * as customSelect from './components/customSelect';
import * as top from './components/top';
import * as tippy from './components/tippy';
import * as menuToggle from './components/menuToggle';
import * as tabs from './components/tabs';
import * as tabsFilter from './components/tabs-filter';
import * as menuSection from './components/menuSection';
import * as search from './components/search';
import * as footer from './components/footer';
import * as toggleAnimate from './components/toggleAnimate';
import * as detectIt from './components/detectIt';
import * as inputDebouncedSubmit from './components/inputDebouncedSubmit';
import * as headerBasket from './components/headerBasket';
import * as header from './components/header';
import * as autoSubmitCheckbox from './components/autoSubmitCheckbox';

// content load components
const componentsload = [
    suggest,
    slick,
    slider,
    fancybox,
];

// once delegated components
const components = [
	// fontFaceObserver,
	transportPayment,
	ajaxFormFancybox,
	fixed,
	linkSlide,
	popupOpen,
	formOpen,
	inpCount,
	menuMain,
	toggleClass,
	customSelect,
	top,
	tippy,
	menuToggle,
	tabs,
	tabsFilter,
	menuSection,
	search,
	footer,
	toggleAnimate,
	detectIt,
	inputDebouncedSubmit,
	headerBasket,
	header,
	autoSubmitCheckbox,
].concat( componentsload );

window.App = {
	run() {
		// MQ('lgUp');

		var $target = $(document);
		components.forEach((component) => component.init( $target ));

		$(document)
			.on('contentload', function(event) {
				var $target = $(event.target);
				componentsload.forEach((component) => component.init( $target ));
			});
	},

	initComponent(component) {
		return component.init();
	},

    initComponents: function initComponents($target) {
        componentsload.forEach(component => component.init($target));
    }
};
